import React from 'react';
import { Button } from 'react-bootstrap';
import './HubClipboardToolbar.scss';

type HubClipboardToolbarProps = {
  selectedCount: number;
  regularCount: number;
  allSelected: boolean;
  isDisabled: boolean;
  isMaxReached: boolean;
  clipboardHasContent: boolean;
  onSelectAll: () => void;
  onDeselectAll: () => void;
  onCopy: () => void;
  onPaste: () => void;
  onDelete: () => void;
};

export function HubClipboardToolbar({
  selectedCount,
  regularCount,
  allSelected,
  isDisabled,
  isMaxReached,
  clipboardHasContent,
  onSelectAll,
  onDeselectAll,
  onCopy,
  onPaste,
  onDelete,
}: HubClipboardToolbarProps) {
  return (
    <div className="hub-clipboard-toolbar">
      <div className="d-flex align-items-center">
        <Button
          variant="outline-secondary"
          size="sm"
          disabled={isDisabled || regularCount === 0}
          onClick={allSelected ? onDeselectAll : onSelectAll}
        >
          {allSelected ? 'Deselect All' : 'Select All'}
        </Button>

        <Button
          variant="outline-primary"
          size="sm"
          className="ml-2"
          disabled={isDisabled || selectedCount === 0}
          onClick={onCopy}
        >
          Copy
        </Button>

        <Button
          variant="outline-primary"
          size="sm"
          className="ml-1"
          disabled={isDisabled || isMaxReached || !clipboardHasContent}
          onClick={onPaste}
        >
          Paste
        </Button>

        {selectedCount > 0 && (
          <>
            <Button
              variant="outline-danger"
              size="sm"
              className="ml-2"
              disabled={isDisabled}
              onClick={onDelete}
            >
              Delete ({selectedCount})
            </Button>
            <span className="hub-clipboard-count ml-2">
              {selectedCount}
              {' '}
              selected
            </span>
          </>
        )}
      </div>
    </div>
  );
}
